export const initialState = {
  messages: [],
  isDeleted: "",
};

export const historyReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GETMESSAGES":
      return {
        ...state,
        messages: action.payload.data.data,
      };
    case "DELETEMESSAGES":
      return {
        ...state,
        isDeleted: action.payload.data.message,
      };
    default:
      return state;
  }
};
